<template>
  <fieldset v-show="!hideChoices">
    <div class="tla-form-group">
      <label class="tla-form-group__label">{{enquiryChoicesComponentText}}</label>
      <div class="tla-form-group__touchpoints tla-form-group__touchpoints--compact">
        <label class="touchpoint">
          <input
            type="checkbox"
            id="quoteRequested"
            class="touchpoint__input"
            v-model="isQuoteRequested" />
          <i class="touchpoint__icon touchpoint__icon--quote" :class="{'is-invalid' : invalid}">
            <span class="touchpoint__name">Quote</span>
          </i>
        </label>
        <label class="touchpoint">
          <input
            type="checkbox"
            id="testDriveRequested"
            class="touchpoint__input"
            v-model="isTestDriveRequested"/>
          <i class="touchpoint__icon touchpoint__icon--test-drive" :class="{'is-invalid' : invalid}">
            <span class="touchpoint__name">Test Drive</span>
          </i>
        </label>
        <label class="touchpoint">
          <input
            type="checkbox"
            id="brochureRequested"
            class="touchpoint__input"
            v-model="isBrochureRequested" />
          <i class="touchpoint__icon touchpoint__icon--brochure" :class="{'is-invalid' : invalid}">
            <span class="touchpoint__name">Brochure</span>
          </i>
        </label>
      </div>
    </div>
    <!-- Hidden input so MVC validation plays nice.-->
    <input type="hidden" name="brochureRequested" :value="isBrochureRequested"/>
    <input type="hidden" name="testDriveRequested" :value="isTestDriveRequested"/>
    <input type="hidden" name="quoteRequested" :value="isQuoteRequested" />

  </fieldset>
</template>

<script lang='ts'>
import { FieldError, Validator } from 'vee-validate';
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import IEnquiryChoices from '@/models/interfaces/IEnquiryChoices';
import { validationService } from '../../services/ValidationService';
import { enquiryService } from '../../services/EnquiryService';
import FormTouchPointComponent from '../ui/FormTouchPointComponent.vue';
import { tokenService } from '../../services/TokenService';

const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  'form-touch-point': FormTouchPointComponent
  }
  })
export default class EnquiryChoicesComponent extends Vue {
  @EnquiryModule.Getter public enquiryChoicesContainsErrors;

  @EnquiryModule.Action public submitQuoteChecked;

  @EnquiryModule.Action public submitTestDriveChecked;

  @EnquiryModule.Action public submitBrochureChecked;

  @EnquiryModule.Action public submitEnquiryChoices;

  @EnquiryModule.Getter public testDriveRequested;

  @EnquiryModule.Getter public quoteRequested;

  @EnquiryModule.Getter public brochureRequested;

  @Prop({ default: 'Service' })
  public enquiryChoicesComponentText!: string;

  @Prop({ default: false })
  public isBrochureEnquiry!: boolean;

  @Prop({ default: false })
  public isQuoteEnquiry!: boolean;

  @Prop({ default: false })
  public isTestDriveEnquiry!: boolean;

  @Prop({ default: false })
  public isBasicEnquiry!: boolean;

  @Prop({ default: false })
  public isDigitalBrochureEnquiry!: boolean;

  @Prop({ default: false })
  public hideChoices!: boolean;

  get isQuoteRequested(): boolean {
    return this.quoteRequested;
  }

  set isQuoteRequested(value: boolean) {
    this.submitQuoteChecked(value);
  }

  get isTestDriveRequested(): boolean {
    return this.testDriveRequested;
  }

  set isTestDriveRequested(value: boolean) {
    this.submitTestDriveChecked(value);
  }

  get isBrochureRequested(): boolean {
    return this.brochureRequested;
  }

  set isBrochureRequested(value: boolean) {
    this.submitBrochureChecked(value);
  }

  get invalid(): boolean {
    return this.enquiryChoicesContainsErrors;
  }

  public mounted() {
    const choices: IEnquiryChoices = {
      isBrochureEnquiry: this.isBrochureEnquiry,
      isTestDriveEnquiry: this.isTestDriveEnquiry,
      isQuoteEnquiry: this.isQuoteEnquiry,
      isDigitalBrochureEnquiry: this.isDigitalBrochureEnquiry,
      isBasicEnquiry: this.isBasicEnquiry,
      isMotabilityEnquiry: false
    };

    this.submitEnquiryChoices(choices);
  }
}
</script>
